export const OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'store-manager-overview',
};
export const OVERVIEW_PRODUCTS_ROUTE = {
    title: `Today's Latest Sold Products`,
    name: 'store-manager-sold-products',
};
export const OVERVIEW_SALES_ROUTE = {
    title: `Today's Sales Amount`,
    name: 'store-manager-sales-amount',
};
export const OVERVIEW_CUSTOMERS_ROUTE = {
    title: `Today's Latest Customers`,
    name: 'store-manager-latest-customers',
};
export const PERFORMANCE_ROUTE = {
    title: 'Store Performance',
    name: 'store-manager-performance',
};
export const PERFORMANCE_POPULAR_PRODUCTS_ROUTE = {
    title: 'Most Viewed Products',
    name: 'store-manager-popular-products',
};
export const PERFORMANCE_PROFITABLE_PRODUCTS_ROUTE = {
    title: 'Most Sold Products',
    name: 'store-manager-profitable-products',
};
export const PRODUCTS_ROUTE = {
    title: 'Products',
    name: 'store-manager-product',
};
export const STORE_ROUTE = {
    title: 'Store',
    name: 'store-manager-store-details',
};
export const STORE_EDIT_ROUTE = {
    title: 'Edit Store',
    name: 'store-manager-store-details-edit',
};
export const PRODUCTS_NEW_ROUTE = {
    title: 'Create Product',
    name: 'store-manager-product-new',
};
export const PRODUCTS_EDIT_ROUTE = {
    title: 'Edit Product',
    name: 'store-manager-product-edit',
};
export const PRODUCTS_DETAILS_ROUTE = {
    title: 'Product Details',
    name: 'store-manager-product-details',
};
export const CATEGORIES_ROUTE = {
    title: 'Categories',
    name: 'store-manager-categories',
};
export const CATEGORIES_NEW_ROUTE = {
    title: 'Create Category',
    name: 'store-manager-category-new',
};
export const CATEGORIES_EDIT_ROUTE = {
    title: 'Edit Category',
    name: 'store-manager-category-edit',
};
export const CATEGORIES_DETAILS_ROUTE = {
    title: 'Category Details',
    name: 'store-manager-category-details',
};
export const ADDONS_ROUTE = {
    title: 'Add-Ons',
    name: 'store-manager-addons',
};
export const ADDONS_NEW_ROUTE = {
    title: 'Create Add-On',
    name: 'store-manager-addons-new',
};
export const ADDONS_EDIT_ROUTE = {
    title: 'Edit Add-On',
    name: 'store-manager-addons-edit',
};
export const ORDERS_ROUTE = {
    title: 'Order Tracker',
    name: 'store-manager-orders-by-status',
};
export const ORDERS_HISTORY_ROUTE = {
    title: 'Order History',
    name: 'store-manager-order-history',
};
export const PAYMENT_ROUTE = {
    title: 'Payment',
    name: 'store-management-payment',
};
export const MERCHANT_REGISTRATION = {
    title: 'Merchant Registration',
    name: 'store-manager-payment-merchant',
};
export const SHIPPING_ROUTE = {
    title: 'Shipping',
    name: 'store-management-shipping',
};
export const SHIPPING_NEW_ROUTE = {
    title: 'Create Shipping',
    name: 'store-management-shipping-new',
};
export const SHIPPING_EDIT_ROUTE = {
    title: 'Edit Shipping',
    name: 'store-management-shipping-edit',
};
export const CUSTOMER_SEGMENT_ROUTE = {
    title: 'Customer Segment',
    name: 'store-management-customers',
};
